module.exports = __webpack_public_path__ + "static/media/debitcard.adcda586.svg";